import { createSlice } from '@reduxjs/toolkit';

export const initialState = {
  data: {
    electricVehicle: null
  }
};

export const slice = createSlice({
  name: 'electricVehicle',
  initialState,
  reducers: {
    setInitialState: (state) => {
      state.data = initialState.data;
    },
    setElectricVehicle: (state, { payload }) => {
      state.data.electricVehicle = payload;
    }
  }
});

export const { setInitialState, setElectricVehicle } = slice.actions;

export const selectSlice = (state) => state[slice.name];
export const selectSliceData = (state) => selectSlice(state).data;
export const selectElectricVehicle = (state) =>
  selectSliceData(state).electricVehicle;

export default slice.reducer;
